function serverTimestamp () {
  try { // if web frontend
    const firebase = require('firebase/app')
    return firebase.firestore.FieldValue.serverTimestamp()
  } catch (e) { // if node.js backend
    try {
      const firestore = require('@google-cloud/firestore')
      return firestore.FieldValue.serverTimestamp()
    } catch (e) {
      return null
    }
  }
}

function getTimestampFromObject (object) {
  try { // if web frontend
    const firebase = require('firebase/app')
    return new firebase.firestore.Timestamp(object.created.seconds, object.created.nanoseconds)
  } catch (e) { // if node.js backend
    try {
      const firestore = require('@google-cloud/firestore')
      return new firestore.Timestamp(object.created.seconds, object.created.nanoseconds)
    } catch (e) {
      return null
    }
  }
}

export function decorateWithTimestampsForFirestore (object, timestamp) {
  let now = timestamp || serverTimestamp()
  if (!object.created) {
    object.created = now
  } else { // re-creating the Timestamp in case the object was serialized
    object.created = getTimestampFromObject(object)
    object.updated = now
  }
  return object
}
export function removeUndefineds (object) {
  Object.keys(object).forEach(prop => {
    if (object[prop] === undefined) {
      delete object[prop]
    }
  })
}
export function removeNulls (object) {
  Object.keys(object).forEach(prop => {
    if (object[prop] === null) {
      delete object[prop]
    }
  })
}
export function removeSlashesFromName (name) {
  let newName = name.replace('/', ', ')
  while (newName.includes('/')) {
    newName = newName.replace('/', ', ')
  }
  return newName
}
export function getDataWithId (firestoreDoc) {
  let data = firestoreDoc.data()
  data.id = firestoreDoc.id
  return data
}
export function getDataWithName (firestoreDoc) {
  let data = firestoreDoc.data()
  data.name = firestoreDoc.id
  return data
}
